import { UPDATE_OBJECT_SELECTED } from '@domain/_redux/pareto-ads-app-redux/action/actionTypes';
import { showErrorToast, showSuccessToast } from '@shared/toasts/toasts.state';
import { INITIAL_SELECTED_GROUP } from '@shared/constants/dashboard/campaign-table-constants';
import { createMiddleware } from '@shared/redux';
import smartViewTexts from '@shared/i18n/overview/texts';
import { getObjectSelectedClient } from '@domain/object-selected/object-selected.state';
import { EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED } from '@domain/segments/segments-modal';
import { convertSegmentPayload } from '@domain/segments/segments.utils';
import { isPlatformViewType } from '@shared/constants/dashboard/campaign-table.utils';
import { SET_OBJECT_TAG } from '@domain/dashboard/budget-manager';
import { isBudgetManagerTagGroup } from '@domain/budget-manager/budget-manager.utils';
import {
    insertGroup,
    editGroup,
    getSelectedGroup,
    setSelectedGroup,
    getClientTagGroups,
    DELETE_SEGMENTS_REQUEST_FAILED,
    DELETE_SEGMENT_REQUEST_SUCCEEDED,
} from './segments.state';

export const segmentsMiddleware = createMiddleware({
    [UPDATE_OBJECT_SELECTED]: (state) => {
        const commonActions = [getClientTagGroups({ clientId: getObjectSelectedClient(state).id })];
        const selectedSegment = getSelectedGroup(state);
        const selectedSegmentIsNotPlatformViewType = !isPlatformViewType(selectedSegment.slug);

        if (selectedSegmentIsNotPlatformViewType) {
            return [
                ...commonActions,
                setSelectedGroup({ group: INITIAL_SELECTED_GROUP }),
            ];
        }

        return commonActions;
    },
    [DELETE_SEGMENTS_REQUEST_FAILED]: () => showErrorToast(
        { message: smartViewTexts.tagsGroup.deleteMessage.error },
    ),
    [DELETE_SEGMENT_REQUEST_SUCCEEDED]: () => showSuccessToast(
        { message: smartViewTexts.tagsGroup.deleteMessage.success },
    ),
    [EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED]: (state, action) => {
        const editedSegment = action.requestAction.payload.segment;
        const isCreatingSegment = !editedSegment.id;
        const insertOrEditGroup = isCreatingSegment ? insertGroup : editGroup;
        const commonActions = [insertOrEditGroup({ group: action.payload.data })];

        const currentSelectedGroup = getSelectedGroup(state);
        const editedGroupIsCurrentSelectedGroup = currentSelectedGroup.slug === editedSegment.slug;

        if (editedGroupIsCurrentSelectedGroup) {
            return [
                ...commonActions,
                setSelectedGroup({
                    group: convertSegmentPayload(action.payload.data),
                }),
            ];
        }

        return commonActions;
    },
    [SET_OBJECT_TAG]: (state, action) => {
        // TODO this is a workaround, OBM it's not updating the segments
        // OBM needs to be refactored https://app.clickup.com/t/1xxj808
        const slectedGroup = getOBMSegments(state);
        const groupEdited = convertOBMCampaignToSegment(action?.config, slectedGroup);
        return [editGroup({ group: groupEdited })];
    },
});

const getOBMSegments = (state) => {
    const { currentSegments } = state.segments;
    const { data } = currentSegments;
    return data.find(group => isBudgetManagerTagGroup(group.slug));
};

const convertOBMCampaignToSegment = (data, group) => {
    const taggedCampaigns = data.reduce((acc, campaign) => {
        if (campaign?.tag?.value) {
            return [...acc, convertCampaignToTaggedCampaign(campaign)];
        }
        return acc;
    }, []);

    return {
        ...group,
        tagged_campaigns: taggedCampaigns,
    };
};

const convertCampaignToTaggedCampaign = campaign => ({
    tags: [campaign.tag.label],
    campaign_id: campaign.campaignId,
    sublevel_id: campaign.sublevelId,
    platform: campaign.platform,
});
